<template>
  <loading-view :loading="loading">
    <div v-if="!loading" class="container mx-6 mt-4">
      <div class="row">
        <div class="col-md-12">
          <billing-current-subscriptions :subscriptions="subscriptions"/>

          <billing-payment-information :user="user"/>

          <billing-invoice-history :invoices="invoices"/>
        </div>
      </div>
    </div>
  </loading-view>
</template>

<script>
import {onUnmounted} from "vue";
import DashboardLayout from "@/Layouts/DashboardLayout"
import BillingCurrentSubscriptions from "@/Pages/Dashboard/Account/Partials/Billing/CurrentSubscriptions"
import BillingPaymentInformation from "@/Pages/Dashboard/Account/Partials/Billing/PaymentInformation";
import BillingInvoiceHistory from "@/Pages/Dashboard/Account/Partials/Billing/InvoiceHistory";

export default {
  name: "Billing",

  components: {
    BillingCurrentSubscriptions,
    BillingPaymentInformation,
    BillingInvoiceHistory
  },

  layout: DashboardLayout,

  props: {
    user: Object
  },

  data() {
    return {
      loading: true,
      subscriptions: [],
      invoices: [],
    }
  },

  async beforeMount() {
    onUnmounted(
      // Prepare information when page is successfully revisited.
      this.$inertia.on('success', () => {
        this.prepareInformation()
      })
    )

    await this.prepareInformation()
  },

  methods: {
    async prepareInformation() {
      this.loading = true

      await Promise.all([
        this.fetchSubscriptions(),
        this.fetchInvoices(),
      ])

      this.loading = false
    },

    async fetchSubscriptions() {
      await axios
        .get(this.$route("dashboard.account.billing.subscriptions"))
        .then(({data}) => this.subscriptions = data.data.subscriptions)
    },

    async fetchInvoices() {
      await axios
        .get(this.$route("dashboard.account.billing.invoices"))
        .then(({data}) => this.invoices = data.data.invoices)
    }
  }
}
</script>
